import { useRouter } from "next/router";
import classNames from "classnames";
import { ReportStatus } from "@entities/history";
import { RouterConfig } from "@shared/lib/routerConfig";
import { Spinner } from "@shared/ui/spinner";
import { HistoryReportListProps } from "./types";
import classes from "./history-report-list.module.scss";

export const HistoryReportList = ({ reports }: HistoryReportListProps) => {
    const router = useRouter();
    if (reports.length === 0) return null;

    const isPending = (status: number) =>
        [ReportStatus.Unknown, ReportStatus.Wait, ReportStatus.Processing].includes(status);

    return (
        <div className={classes["report-list"]}>
            {reports.map(({ id, brand, model, year, vin, status }) => {
                const pending = isPending(status);

                const handleClick = () => {
                    if (!pending) {
                        router.push(`${RouterConfig.HISTORY}/report/${id}`);
                    }
                };

                return (
                    <div
                        key={id}
                        onClick={handleClick}
                        role="button"
                        tabIndex={0}
                        className={classNames(classes["report-list__item"], {
                            [classes["report-list__item--pending"]]: pending
                        })}
                    >
                        <div className={classes["report-list__info"]}>
                            <div className={classes["report-list__title"]}>
                                {brand} {model}, {year}
                            </div>
                            <div className={classes["report-list__vin"]}>{vin}</div>
                        </div>
                        <div className={classes["report-list__actions"]}>
                            {pending ? (
                                <Spinner size={18} />
                            ) : (
                                <a
                                    className={classes["report-list__link"]}
                                    href={`${RouterConfig.HISTORY}/report/${id}?pdf=download`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    Скачать PDF
                                </a>
                            )}
                            <span className={classes["report-list__source"]}>
                                Источник: Автотека
                            </span>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};